exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_Divider_Fch3ATHtwZ__7iMr80RJB {\n  display: flex;\n  width: 100%;\n  margin-bottom: 20px;\n\n}\n\n.IA_dropZones_36OTfPm6bCfvkANKxjt9uA {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n  position: relative;\n}", ""]);

// Exports
exports.locals = {
	"IA_Divider": "IA_Divider_Fch3ATHtwZ__7iMr80RJB",
	"IA_dropZones": "IA_dropZones_36OTfPm6bCfvkANKxjt9uA"
};